module.exports = __webpack_public_path__ + "img/0326.ef8c1bbd.jpeg";